// The options of job search's Work Authorization filter: each URL code and the job-form choice it
// stands for, which is what a job stores in `workAuthReqJob`.
//
// One list for the filter panel, the API server's matching and the server-rendered query, so a code
// cannot be offered in one place and unknown in another.
//
// Written as plain CommonJS so the API server, which runs its files under plain node, can require
// this same file the browser bundle imports.

const { CITIZENSHIP_REQUIREMENTS } = require('./citizenshipRequirement');

const US_CITIZENSHIP_REQUIRED = CITIZENSHIP_REQUIREMENTS[0];
const GREEN_CARD_HOLDER = CITIZENSHIP_REQUIREMENTS[1];

const JOB_WORK_AUTHORIZATION_FILTER_OPTIONS = [
  { option: 'authorized_no_sponsorship', label: 'Authorized to work in the U.S. without employer sponsorship' },
  {
    option: 'authorized_requires_sponsorship',
    label: 'Authorized to work in the U.S. and requires current/future employer sponsorship',
  },
  {
    option: 'authorized_limited_duration',
    label: 'Authorized to work in the U.S. for a limited duration (with valid work authorization/EAD)',
  },
  { option: 'us_citizenship_required', label: US_CITIZENSHIP_REQUIRED },
  { option: 'green_card_holder', label: GREEN_CARD_HOLDER },
];

module.exports = { JOB_WORK_AUTHORIZATION_FILTER_OPTIONS };
